export const FLEX_TASKS_QUERY_KEY = 'flexMatchTasks' as const;
export const CANDIDATES_QUERY_KEY = 'flexMatchCandidates' as const;
export const REQUEST_NOTES_QUERY_KEY = 'requestNotes' as const;
export const REQUEST_QUALIFICATIONS_QUERY_KEY =
  'requestQualifications' as const;
